import { Component, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { TimeOffType } from '@app/models/time-off-v3/time-off-type.model';
import { BaseForm } from '@forms/base.form';

@Component({
    selector: 'app-time-off-types-form',
    templateUrl: './types.form.html',
    styleUrls: ['./types.form.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class TypesForm extends BaseForm {
    @Input() timeOffType = new TimeOffType();
    @Input() isUpdate = false;
}
